import { makeFunctionReference } from 'convex/server';
import type { Id } from '@/convex/_generated/dataModel';

export type VoiceAvatarVisibility = 'always' | 'during-call';

export const getVoicePreferences = makeFunctionReference<
  'query',
  { orgSlug: string },
  { visibility: VoiceAvatarVisibility }
>('your_imai/voice_preferences:get');
export const setVoicePreferences = makeFunctionReference<
  'mutation',
  { orgSlug: string; visibility: VoiceAvatarVisibility },
  null
>('your_imai/voice_preferences:set');
export const sendYourImaiVoice = makeFunctionReference<
  'mutation',
  {
    orgThreadId: Id<'orgThreads'>;
    sessionId: string;
    clientInputId: string;
    prompt: string;
  },
  { delivery: 'sent' | 'steered' | 'queued' }
>('your_imai/voice:send');
